module.exports = __webpack_public_path__ + "img/burger-icon.71d1b572.svg";